import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../configs";

const BASE_URL = config.REACT_APP_BASE_URL ?? "";


export const MASTER_TOKEN_KEY = "masterToken";


export const masterApi = createApi({
  reducerPath: "masterApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/api/master-users`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem(MASTER_TOKEN_KEY);
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Customers"],
  endpoints: (builder) => ({
    masterLogin: builder.mutation<
      ApiResponse<MasterLoginResponse>,
      { email: string; password: string }
    >({
      query: (body) => ({ url: "login", method: "POST", body }),
    }),
    getMasterCustomers: builder.query<
      ApiResponse<PaginatedCustomers>,
      GetCustomersArgs | void
    >({
      query: (args) => {
        const { page = 1, limit = 20, search = "", isTestUser } = args ?? {};
        const params = new URLSearchParams({
          page: String(page),
          limit: String(limit),
        });
        if (search.trim()) params.set("search", search.trim());
        if (isTestUser !== undefined) params.set("isTestUser", String(isTestUser));
        return `users?${params.toString()}`;
      },
      providesTags: ["Customers"],
    }),
    impersonateCustomer: builder.mutation<ApiResponse<ImpersonateResponse>, string>({
      query: (userId) => ({ url: `impersonate/${userId}`, method: "POST" }),
    }),
    // Validates the current master token at the backend and returns the master
    // user. Lets us confirm "this is a master user" instead of trusting
    // localStorage; a 401 means the token is missing/invalid/expired/deleted.
    getMasterMe: builder.query<ApiResponse<MasterUser>, void>({
      query: () => "me",
    }),
  }),
});

export const {
  useMasterLoginMutation,
  useGetMasterCustomersQuery,
  useImpersonateCustomerMutation,
  useGetMasterMeQuery,
} = masterApi;
